import { render, staticRenderFns } from "./ShareInformation.vue?vue&type=template&id=3143659b&scoped=true&"
import script from "./ShareInformation.vue?vue&type=script&lang=js&"
export * from "./ShareInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143659b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3143659b')) {
      api.createRecord('3143659b', component.options)
    } else {
      api.reload('3143659b', component.options)
    }
    module.hot.accept("./ShareInformation.vue?vue&type=template&id=3143659b&scoped=true&", function () {
      api.rerender('3143659b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoSheet/ShareInformation.vue"
export default component.exports